import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["content", "buttonType", "autoFocus"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React__default, { useRef, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { get } from '../constants.js';
import { useFocusTrap } from '../hooks/useFocusTrap.js';
import sx from '../sx.js';
import { XIcon } from '@primer/octicons-react';
import { useFocusZone } from '../hooks/useFocusZone.js';
import { FocusKeys } from '@primer/behaviors';
import { Portal } from '../Portal/Portal.js';
import { useRefObjectAsForwardedRef } from '../hooks/useRefObjectAsForwardedRef.js';
import { useId } from '../hooks/useId.js';
import Button from '../deprecated/Button/Button.js';
import { useOnEscapePress } from '../hooks/useOnEscapePress.js';
import { useProvidedRefOrCreate } from '../hooks/useProvidedRefOrCreate.js';
import Octicon from '../Octicon/Octicon.js';
import Box from '../Box/Box.js';
import ButtonPrimary from '../deprecated/Button/ButtonPrimary.js';
import ButtonDanger from '../deprecated/Button/ButtonDanger.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/* Dialog Version 2 */

var ANIMATION_DURATION = '200ms';

/**
 * Props that characterize a button to be rendered into the footer of
 * a Dialog.
 */

/**
 * Props to customize the rendering of the Dialog.
 */

/**
 * Props that are passed to a component that serves as a dialog header
 */

var Backdrop = styled('div').withConfig({
  displayName: "Dialog__Backdrop",
  componentId: "sc-uaxjsn-0"
})(["position:fixed;top:0;left:0;bottom:0;right:0;display:flex;align-items:center;justify-content:center;background-color:", ";animation:dialog-backdrop-appear ", " ", ";@keyframes dialog-backdrop-appear{0%{opacity:0;}100%{opacity:1;}}"], get('colors.primer.canvas.backdrop'), ANIMATION_DURATION, get('animation.easeOutCubic'));
var heightMap = {
  small: '480px',
  large: '640px',
  auto: 'auto'
};
var widthMap = {
  small: '296px',
  medium: '320px',
  large: '480px',
  xlarge: '640px'
};
var StyledDialog = styled.div.withConfig({
  displayName: "Dialog__StyledDialog",
  componentId: "sc-uaxjsn-1"
})(["display:flex;flex-direction:column;background-color:", ";box-shadow:", ";min-width:296px;max-width:calc(100vw - 64px);max-height:calc(100vh - 64px);width:", ";height:", ";border-radius:12px;opacity:1;animation:overlay--dialog-appear ", " ", ";@keyframes overlay--dialog-appear{0%{opacity:0;transform:scale(0.5);}100%{opacity:1;transform:scale(1);}}", ";"], get('colors.canvas.overlay'), get('shadows.overlay.shadow'), function (props) {
  var _props$width;
  return widthMap[(_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 'xlarge'];
}, function (props) {
  var _props$height;
  return heightMap[(_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'auto'];
}, ANIMATION_DURATION, get('animation.easeOutCubic'), sx);
var DefaultHeader = function DefaultHeader(_ref) {
  var dialogLabelId = _ref.dialogLabelId,
    title = _ref.title,
    subtitle = _ref.subtitle,
    dialogDescriptionId = _ref.dialogDescriptionId,
    onClose = _ref.onClose;
  var onCloseClick = useCallback(function () {
    onClose('close-button');
  }, [onClose]);
  return /*#__PURE__*/React__default.createElement(Dialog.Header, null, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    px: 2,
    py: "6px",
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/React__default.createElement(Dialog.Title, {
    id: dialogLabelId
  }, title !== null && title !== void 0 ? title : 'Dialog'), subtitle && /*#__PURE__*/React__default.createElement(Dialog.Subtitle, {
    id: dialogDescriptionId
  }, subtitle)), /*#__PURE__*/React__default.createElement(Dialog.CloseButton, {
    onClose: onCloseClick
  })));
};
DefaultHeader.displayName = "DefaultHeader";
var DefaultBody = function DefaultBody(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement(Dialog.Body, null, children);
};
DefaultBody.displayName = "DefaultBody";
var DefaultFooter = function DefaultFooter(_ref3) {
  var footerButtons = _ref3.footerButtons;
  var _useFocusZone = useFocusZone({
      bindKeys: FocusKeys.ArrowHorizontal | FocusKeys.Tab,
      focusInStrategy: 'closest'
    }),
    footerRef = _useFocusZone.containerRef;
  return footerButtons ? /*#__PURE__*/React__default.createElement(Dialog.Footer, {
    ref: footerRef
  }, /*#__PURE__*/React__default.createElement(Dialog.Buttons, {
    buttons: footerButtons
  })) : null;
};
var _Dialog = /*#__PURE__*/React__default.forwardRef(function (props, forwardedRef) {
  var _props$title = props.title,
    title = _props$title === void 0 ? 'Dialog' : _props$title,
    _props$subtitle = props.subtitle,
    subtitle = _props$subtitle === void 0 ? '' : _props$subtitle,
    renderHeader = props.renderHeader,
    renderBody = props.renderBody,
    renderFooter = props.renderFooter,
    onClose = props.onClose,
    _props$role = props.role,
    role = _props$role === void 0 ? 'dialog' : _props$role,
    _props$width2 = props.width,
    width = _props$width2 === void 0 ? 'xlarge' : _props$width2,
    _props$height2 = props.height,
    height = _props$height2 === void 0 ? 'auto' : _props$height2,
    _props$footerButtons = props.footerButtons,
    footerButtons = _props$footerButtons === void 0 ? [] : _props$footerButtons,
    sx = props.sx;
  var dialogLabelId = useId();
  var dialogDescriptionId = useId();
  var autoFocusedFooterButtonRef = useRef(null);
  var _iterator = _createForOfIteratorHelper(footerButtons),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var footerButton = _step.value;
      if (footerButton.autoFocus) {
        footerButton.ref = autoFocusedFooterButtonRef;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var defaultedProps = _objectSpread(_objectSpread({}, props), {}, {
    title: title,
    subtitle: subtitle,
    role: role,
    dialogLabelId: dialogLabelId,
    dialogDescriptionId: dialogDescriptionId
  });
  var dialogRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, dialogRef);
  var backdropRef = useRef(null);
  useFocusTrap({
    containerRef: dialogRef,
    restoreFocusOnCleanUp: true,
    initialFocusRef: autoFocusedFooterButtonRef
  });
  useOnEscapePress(function (event) {
    onClose('escape');
    event.preventDefault();
  }, [onClose]);
  React__default.useEffect(function () {
    var bodyOverflowStyle = document.body.style.overflow || '';
    // If the body is already set to overflow: hidden, it likely means
    // that there is already a modal open. In that case, we should bail
    // so we don't re-enable scroll after the second dialog is closed.
    if (bodyOverflowStyle === 'hidden') {
      return;
    }
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = bodyOverflowStyle;
    };
  }, []);
  var header = (renderHeader !== null && renderHeader !== void 0 ? renderHeader : DefaultHeader)(defaultedProps);
  var body = (renderBody !== null && renderBody !== void 0 ? renderBody : DefaultBody)(defaultedProps);
  var footer = (renderFooter !== null && renderFooter !== void 0 ? renderFooter : DefaultFooter)(defaultedProps);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement(Backdrop, {
    ref: backdropRef
  }, /*#__PURE__*/React__default.createElement(StyledDialog, {
    width: width,
    height: height,
    ref: dialogRef,
    role: role,
    "aria-labelledby": dialogLabelId,
    "aria-describedby": dialogDescriptionId,
    "aria-modal": true,
    sx: sx
  }, header, body, footer))));
});
_Dialog.displayName = 'Dialog';
var Header = styled.div.withConfig({
  displayName: "Dialog__Header",
  componentId: "sc-uaxjsn-2"
})(["box-shadow:0 1px 0 ", ";padding:", ";z-index:1;flex-shrink:0;"], get('colors.border.default'), get('space.2'));
var Title = styled.h1.withConfig({
  displayName: "Dialog__Title",
  componentId: "sc-uaxjsn-3"
})(["font-size:", ";font-weight:", ";margin:0;", ";"], get('fontSizes.1'), get('fontWeights.bold'), sx);
var Subtitle = styled.h2.withConfig({
  displayName: "Dialog__Subtitle",
  componentId: "sc-uaxjsn-4"
})(["font-size:", ";color:", ";margin:0;margin-top:", ";", ";"], get('fontSizes.0'), get('colors.fg.muted'), get('space.1'), sx);
var Body = styled.div.withConfig({
  displayName: "Dialog__Body",
  componentId: "sc-uaxjsn-5"
})(["flex-grow:1;overflow:auto;padding:", ";", ";"], get('space.3'), sx);
var Footer = styled.div.withConfig({
  displayName: "Dialog__Footer",
  componentId: "sc-uaxjsn-6"
})(["box-shadow:0 -1px 0 ", ";padding:", ";display:flex;flex-flow:wrap;justify-content:flex-end;z-index:1;flex-shrink:0;button{margin-left:", ";&:first-child{margin-left:0;}}", ";"], get('colors.border.default'), get('space.3'), get('space.1'), sx);
var buttonTypes = {
  normal: Button,
  primary: ButtonPrimary,
  danger: ButtonDanger
};
var Buttons = function Buttons(_ref4) {
  var buttons = _ref4.buttons;
  var _buttons$find;
  var autoFocusRef = useProvidedRefOrCreate((_buttons$find = buttons.find(function (button) {
    return button.autoFocus;
  })) === null || _buttons$find === void 0 ? void 0 : _buttons$find.ref);
  var autoFocusCount = 0;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    hasRendered = _useState2[0],
    setHasRendered = _useState2[1];
  useEffect(function () {
    // hack to work around dialogs originating from other focus traps.
    if (hasRendered === 1) {
      var _autoFocusRef$current;
      (_autoFocusRef$current = autoFocusRef.current) === null || _autoFocusRef$current === void 0 ? void 0 : _autoFocusRef$current.focus();
    } else {
      setHasRendered(hasRendered + 1);
    }
  }, [autoFocusRef, hasRendered]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, buttons.map(function (dialogButtonProps, index) {
    var content = dialogButtonProps.content,
      _dialogButtonProps$bu = dialogButtonProps.buttonType,
      buttonType = _dialogButtonProps$bu === void 0 ? 'normal' : _dialogButtonProps$bu,
      _dialogButtonProps$au = dialogButtonProps.autoFocus,
      autoFocus = _dialogButtonProps$au === void 0 ? false : _dialogButtonProps$au,
      buttonProps = _objectWithoutProperties(dialogButtonProps, _excluded);
    var ButtonElement = buttonTypes[buttonType];
    return /*#__PURE__*/React__default.createElement(ButtonElement, _extends({
      key: index
    }, buttonProps, {
      variant: buttonType,
      ref: autoFocus && autoFocusCount === 0 ? (autoFocusCount++, autoFocusRef) : null
    }), content);
  }));
};
var DialogCloseButton = styled(Button).withConfig({
  displayName: "Dialog__DialogCloseButton",
  componentId: "sc-uaxjsn-7"
})(["border-radius:4px;background:transparent;border:0;vertical-align:middle;color:", ";padding:", ";align-self:flex-start;line-height:normal;box-shadow:none;"], get('colors.fg.muted'), get('space.2'));
var CloseButton = function CloseButton(_ref5) {
  var onClose = _ref5.onClose;
  return /*#__PURE__*/React__default.createElement(DialogCloseButton, {
    "aria-label": "Close",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(Octicon, {
    icon: XIcon
  }));
};
CloseButton.displayName = "CloseButton";
/**
 * A dialog is a type of overlay that can be used for confirming actions, asking
 * for disambiguation, and presenting small forms. They generally allow the user
 * to focus on a quick task without having to navigate to a different page.
 *
 * Dialogs appear in the page after a direct user interaction. Don't show dialogs
 * on page load or as system alerts.
 *
 * Dialogs appear centered in the page, with a visible backdrop that dims the rest
 * of the window for focus.
 *
 * All dialogs have a title and a close button.
 *
 * Dialogs are modal. Dialogs can be dismissed by clicking on the close button,
 * pressing the escape key, or by interacting with another button in the dialog.
 * To avoid losing information and missing important messages, clicking outside
 * of the dialog will not close it.
 *
 * The sub components provided (e.g. Header, Title, etc.) are available for custom
 * renderers only. They are not intended to be used otherwise.
 */
var Dialog = Object.assign(_Dialog, {
  Header: Header,
  Title: Title,
  Subtitle: Subtitle,
  Body: Body,
  Footer: Footer,
  Buttons: Buttons,
  CloseButton: CloseButton
});
export { Dialog };